import { Markdown } from "@/components/ai/chat/Markdown";
import type { AgentMessageFragmentText } from "@/hooks/use-stream-conversation";
import { type FC } from "react";

export const FragmentText: FC<{
    fragment: AgentMessageFragmentText;
}> = ({ fragment }) => {
    return (
        <div data-completed={fragment.completed}>
            <Markdown content={fragment.content} />
        </div>
    );
};
